import { render, staticRenderFns } from "./FlayerJungle.vue?vue&type=template&id=0be37451"
import script from "./FlayerJungle.vue?vue&type=script&lang=js"
export * from "./FlayerJungle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports